export const typography = {
	body: {
		body1: {
			fontSize: "1rem", // 16px
			fontStyle: "normal",
			fontWeight: 400,
			letterSpacing: "0.15px",
			lineHeight: "150%"
		},
		body2: {
			fontSize: "0.875rem", // 14px
			fontStyle: "normal",
			fontWeight: 400,
			letterSpacing: "0.17px",
			lineHeight: "143%"
		}
	},
	caption: {
		fontSize: "0.75rem", // 12px
		fontStyle: "normal",
		fontWeight: 400,
		letterSpacing: "0.4px",
		lineHeight: "166%"
	},
	chipLabel: {
		fontSize: "0.875rem", // 14px
		fontStyle: "normal",
		fontWeight: 500,
		letterSpacing: "0.46px",
		lineHeight: "18px"
	},
	heading: {
		h1: {
			fontSize: "6rem", // 96px
			fontStyle: "normal",
			fontWeight: 300,
			letterSpacing: "0.46px",
			lineHeight: "116.7%"
		},
		h2: {
			fontSize: "3.75rem", // 60px
			fontStyle: "normal",
			fontWeight: 300,
			letterSpacing: "1px",
			lineHeight: "120%"
		},
		h3: {
			fontSize: "3rem", // 48px
			fontStyle: "normal",
			fontWeight: 500,
			lineHeight: "116.7%"
		},
		h4: {
			fontSize: "2.125rem", // 34px
			fontStyle: "normal",
			fontWeight: 300,
			letterSpacing: "1px",
			lineHeight: "123.5%"
		},
		h5: {
			fontSize: "1.5rem", // 24px
			fontStyle: "normal",
			fontWeight: 400,
			lineHeight: "133.4%"
		},
		h6: {
			fontSize: "1.25rem", // 20px
			fontStyle: "normal",
			fontWeight: 500,
			letterSpacing: "0.15px",
			lineHeight: "160%"
		}
	},
	menu: {
		menuItem: {
			fontWeight: "400",
			fontSize: "16px",
			lineHeight: "150%",
			letterSpacing: "0.15px"
		}
	},
	overline: {
		fontSize: "0.75rem", // 12px
		fontStyle: "normal",
		fontWeight: 400,
		letterSpacing: "1px",
		lineHeight: "266%",
		textTransform: "uppercase"
	},
	subtitle: {
		subtitle1: {
			fontSize: "1rem", // 16px
			fontStyle: "normal",
			fontWeight: 400,
			letterSpacing: "1px",
			lineHeight: "175%",
			textTransform: "uppercase"
		},
		subtitle2: {
			fontSize: "0.875rem", // 14px
			fontStyle: "normal",
			fontWeight: 500,
			letterSpacing: "0.1px",
			lineHeight: "157%"
		}
	},
	alert: {
		alertTitle: {
			fontSize: "1rem", // 16px
			fontStyle: "normal",
			fontWeight: 500,
			letterSpacing: "0.15px",
			lineHeight: "150%"
		},
		alertDescription: {
			fontSize: "0.875rem", // 14px
			fontStyle: "medium",
			fontWeight: 500,
			letterSpacing: "0.15px",
			lineHeight: "143%",
			margin: 0
		}
	}
} as const;
